import { useReveal } from "../../lib/hooks";

const ACTIVITIES = [
  {
    numeral: "I",
    title: "Recitation of the Vedas",
    body: "Daily online chanting and regular in-person gatherings — drawing mainly from the Ṛgveda, Yajurveda, and Atharvaveda. The mantras carried by the voice, together, in their original sound.",
  },
  {
    numeral: "II",
    title: "Bhajan, pūjā & devotion",
    body: "Devotional song, traditional pūjā, and seva — the shared warmth of practice in community, online and in person. We don't prescribe one sādhanā. People come with their own path; what we hold together is the wider tradition.",
  },
  {
    numeral: "III",
    title: "Rudram & special yajñas",
    body: "Recurring Rudram gatherings — chanting the Śrī Rudram together — and occasional yajñas for special moments, like the Ati Rudra Mahā Yajña in Zagreb and the Śrī Gāyatrī Mahā Yajña.",
  },
  {
    numeral: "IV",
    title: "Study & worldwide network",
    body: "Workshops on the meaning of the Vedas, study programmes, and written and audio materials. A network connecting chanting groups, teachers, and seekers across countries, languages, and traditions.",
  },
] as const;

export function Activities() {
  const { ref } = useReveal<HTMLDivElement>();

  return (
    <section className="py-20 md:py-28">
      <div className="container-edit">
        <div className="section-heading">
          <span className="section-heading-num tabular">02 / Activities</span>
          <hr className="rule flex-1 hidden sm:block" />
        </div>

        <h2 className="font-display text-[clamp(2.5rem,6vw,5rem)] leading-[1.02] tracking-[-0.02em] mb-14 md:mb-16 max-w-[18ch]">
          What we do, &nbsp;<span className="font-display-italic" style={{ color: "var(--color-violet)" }}>together</span>.
        </h2>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 reveal-stagger">
          {ACTIVITIES.map((a) => (
            <article key={a.numeral} className="grid grid-cols-[auto_1fr] gap-x-8">
              <span className="numeral mt-[-0.4rem]">{a.numeral}</span>
              <div>
                <h3 className="font-display text-[1.85rem] md:text-[2.1rem] leading-tight mb-4 tracking-tight">
                  {a.title}
                </h3>
                <hr className="rule mb-5 max-w-[3rem]" />
                <p className="text-[1.0625rem] leading-[1.7] text-[var(--color-ink-soft)] max-w-[44ch]">
                  {a.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
